import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import getSearchParams from './getSearchParams';

function withQuery(InnerComp) {
  @connect(controller)
  class QueryProvider extends React.Component {
    static contextTypes = {
      logger: PropTypes.object,
    };

    UNSAFE_componentWillMount() {
      const {history, location, updateQuery, replaceQuery} = this.props;
      const {logger} = this.context;

      updateQuery({
        query: getSearchParams(location.search),
      });
      if (history) {
        history.listen((location, action) => {
          logger.info(`The current URL is ${location.pathname}${location.search}${location.hash}`, location);
          logger.info(`The last navigation action was ${action}`);
          replaceQuery({
            query: getSearchParams(location.search),
          });
        });
      }
    }

    render() {
      const {query, ...props} = this.props;

      return <InnerComp {...props} />;
    }
  }

  QueryProvider.propTypes = {
    /** Object Containing the Parsed URL Information  */
    location: PropTypes.object,

    /** The router history object */
    history: PropTypes.object,

    /** Function called to update query */
    updateQuery: PropTypes.func,

    /** Update query function */
    replaceQuery: PropTypes.func,

    /** The query in object format */
    query: PropTypes.object,
  };

  return withRouter(QueryProvider);
}

export default withQuery;
